<ng-container *ngIf="false == isParkerEditMode">
    
        <mat-card class="card-title-only card-grid-border">
            <mat-card-content>
    
    <div class="container-full" style="height:450px;">
        <div class="row">
                <div class="col-4">
                    <mat-card>
                        <mat-card-content>
                            <div *ngIf="false == isParkerEligibleForEdit()">
                            <span style="position:relative;top:-14px;margin-left:15px;"  matTooltip="Edit Parker" class="mimic-button-hover">Another Profile is being changed. Save/Cancel before editing this profile.</span>        
                            </div>
                            <div *ngIf="isParkerEligibleForEdit()">
                            <mat-icon *ngIf="false == isParkerEditMode" class="detail-nav-button" aria-hidden="false" aria-label="Example home icon" fontIcon="edit" (click)="onPerformParkerEdit()" matTooltip="Edit Parker" style="height:20px;width:20px;margin-bottom:10px;"></mat-icon>
                            <span style="position:relative;top:-14px;margin-left:15px;"  matTooltip="Edit Parker" class="mimic-button-hover" (click)="onPerformParkerEdit()" >Edit Parker</span>
                            </div>
                            <br /><span class="ace-title-level-2">{{parkerDetail.companyName}}</span>
                            <button mat-icon-button aria-label="Copy Company Name" [cdkCopyToClipboard]="parkerDetail.companyName"   matTooltip="Copy Company Name"  (click)="onCopyMessage('Company Name copied to clipboard')">
                                <mat-icon>content_copy</mat-icon>
                            </button>
                            <br />Parker Id: <strong>{{parkerDetail.parkerId}}</strong>
                            <button mat-icon-button aria-label="Copy Parker Id" [cdkCopyToClipboard]="parkerDetail.parkerId"  matTooltip="Copy Parker Id" (click)="onCopyMessage('Parker Id copied to clipboard')">
                                <mat-icon>content_copy</mat-icon>
                              </button>
                            @if(spaceUserId != undefined){
                            <br />Space User Id: <strong>{{spaceUserId}}</strong>
                            <button mat-icon-button aria-label="Copy Space User Id" [cdkCopyToClipboard]="spaceUserId.toString()"  matTooltip="Copy Space User Id" (click)="onCopyMessage('Space User Id copied to clipboard')">
                                <mat-icon>content_copy</mat-icon>
                              </button>
                            }
                            @else{
                                <br />Space User Id: <strong>--</strong>
                            }
                            <br />
                            Parker Name: <strong>{{parkerDetail.lastName}}, {{parkerDetail.firstName}}</strong>
                            <button mat-icon-button aria-label="Copy Parker Name" [cdkCopyToClipboard]="parkerNameLastFirstForCopy"  matTooltip="Copy Parker Name" (click)="onCopyMessage('Parker Name copied to clipboard')">
                                <mat-icon>content_copy</mat-icon>
                              </button>
                            <br />
                            Status:  <strong>@if(parkerDetail.active == 'A')
                                        {<span style="margin-left:5px;color:green;">Active</span>}
                                    @else
                                        {<span style="margin-left:5px;color:red;">Inactive</span>}
                                    </strong>    
                                    <br />
                            Invoice Delivery: <strong>{{parkerDetail.deliveryType}}</strong><br />
                            Card Number: @if(parkerDetail.cardNumber != ''){<strong>{{parkerDetail.cardNumber}}</strong>
                                <button mat-icon-button aria-label="Copy Card Number" [cdkCopyToClipboard]="parkerDetail.cardNumber" style="position:relative;top: 0px;margin-left:5px;"   
                                        matTooltip="Copy Parker Card number"  (click)="onCopyMessage('Parker Card Number copied to clipboard')">
                                    <mat-icon>content_copy</mat-icon>
                                </button>}
                            @else{--}
                            <br />
                            Email Address: <strong>{{parkerDetail.emailAddress}}</strong>            
                            @if(parkerDetail.emailAddress != '')
                            {
                                <button mat-icon-button aria-label="Copy Email Address" [cdkCopyToClipboard]="parkerDetail.emailAddress" style="position:relative;top: 0px;margin-left:5px;"   
                                            matTooltip="Copy Parker Primary Email"  (click)="onCopyMessage('Parker Primary Email copied to clipboard')">
                                    <mat-icon>content_copy</mat-icon>
                                </button>
                            }
                            @else{--}
                            <br />
                            Phone: @if(parkerDetail.phone != ''){<strong>{{parkerDetail.phone}}</strong>             
                                <button mat-icon-button aria-label="Copy Phone Number" [cdkCopyToClipboard]="parkerDetail.phone" style="position:relative;top: 0px;margin-left:5px;"   
                                    matTooltip="Copy Parker Phone Number"  (click)="onCopyMessage('Parker Phone Number copied to clipboard')">
                                    <mat-icon>content_copy</mat-icon>
                                </button>
                            } @else {--} <br />
                            Start Date: <strong>{{parkerDetail.startDate | date : 'shortDate'}}</strong><br />
                            End Date: <strong>{{displayEndDate}}</strong>
                        </mat-card-content>
                    </mat-card>
                </div>
                <div class="col-4">
                    <mat-card>
                        <mat-card-content>
                            <span class="ace-title-level-2">Rate Summary</span><br />
                            Description: <strong>{{parkerDetail.rateDescription}}</strong><br />
                            Stall Type: <strong>{{parkerDetail.stallType}}</strong><br />
                            Rate: <strong>{{parkerDetail.rate | currency}}</strong><br />
                            @if(parkerDetail.taxExempt){
                                Tax Exempt: <strong>Yes</strong>
                            }
                            @else {
                                Tax Exempt: <strong>No</strong>
                            }<br />
                            @if(parkerDetail.stallNumber !== ''){
                                Stall Number: <strong>{{parkerDetail.stallNumber}}</strong>
                            }
                            @else {
                                Stall Number: --
                            }
                            
                        </mat-card-content>
                    </mat-card>
                    <mat-card class="mt-1">
                        <mat-card-content>
                        @if(parkerDetail != null && parkerDetail != undefined){
                            @if(
                                 parkerDetail.address != ''
                                ||  parkerDetail.addressLine != ''
                                ||  parkerDetail.city != ''
                                ||  parkerDetail.state != ''
                                ||  parkerDetail.zipCode != '')
                            {
                                <strong>Billing Address</strong>
                                <button mat-icon-button aria-label="Copy Billing Address" [cdkCopyToClipboard]="addressForCopy" style="position:relative;top: 0px;margin-left:5px;"   
                                matTooltip="Copy Billing Address"  (click)="onCopyMessage('Address Information copied to clipboard')">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                                <br />
                                @if(parkerDetail.address != ''){
                                    <br />{{parkerDetail.address}}
                                }
                                @if(parkerDetail.addressLine != ''){
                                    <br />{{parkerDetail.addressLine}}
                                }
                                @if(parkerDetail.city != '' && parkerDetail.state != '' && parkerDetail.zipCode){
                                    <br />{{parkerDetail.city}} {{parkerDetail.state}} {{parkerDetail.zipCode}}
                                }
                            }
                            @else {
                                <strong>Billing Address</strong><br />
                                <span>-- No Address Available --</span>
                            }
                        }
                        @else
                        {
                            no parker data exists 2
                        }
    
                            <hr />
                         
                        </mat-card-content>
                    </mat-card>

                    
                </div>
    
                <div class="col-4">
                    <mat-card>
                        <mat-card-content>
                            <span class="ace-title-level-2">spACE</span><br />
                            Portal User: <strong>@if(parkerDetail.isAcePortal == true){Yes}@else{No}</strong><br />
                            Card On File: <strong>@if(parkerDetail.isPortalCreditCardOnFile == true){Yes}@else{No}</strong><br />
                            Auto Pay: <strong>@if(parkerDetail.isPortalAutoPay == true){Yes}@else{No}</strong><br />
                            @if(parkerDetail.autopayDay == 0){
                                Auto Pay Day: <strong>--</strong>
                            }
                            @else {
                                Auto Pay Day: <strong>{{parkerDetail.autopayDay}}</strong>
                            }
                        </mat-card-content>
                    </mat-card>

                    <mat-card style="margin-top:20px;">
                        <mat-card-content>
                            
                            @if(
                                vehicleData != null && vehicleData != undefined &&
                                (vehicleData.vehicleLicense != ''
                                ||  vehicleData.vehicleMake != ''
                                ||  vehicleData.vehicleModel != ''
                                ||  vehicleData.vehicleState != ''
                                ||  vehicleData.vehicleColor != '')
                            )
                                {
                                    <span class="ace-title-level-2">Vehicle(s) Information ({{parkerDetail.additionalVehicles}})</span>
                                @if(vehicleData.vehicleLicense != ''){
                                    <br />License Plate: <strong>{{vehicleData.vehicleLicense}}</strong>
                                    <button mat-icon-button aria-label="Copy Vehicle License Plate" [cdkCopyToClipboard]="vehicleData.vehicleLicense" style="position:relative;top: 0px;margin-left:5px;"   
                                    matTooltip="Copy Vehicle License Plate"  (click)="onCopyMessage('Vehicle License Plate copied to clipboard')">
                                <mat-icon>content_copy</mat-icon>
                                </button>
                                }
                                @if(vehicleData.vehicleMake != '' || vehicleData.vehicleModel != '' || vehicleData.vehicleState != '') {
                                    <br />{{vehicleData.vehicleMake}} {{vehicleData.vehicleModel}} {{vehicleData.vehicleState}} 
                                }
                                @if(vehicleData.vehicleColor != ''){
                                    <br />{{vehicleData.vehicleColor}}
                                }
                               
    
                            }
                            @else {
                                <span class="ace-title-level-2">Vehicle Information</span><br />
                                Not on file
                            }
    
                            <hr />
                         
                        </mat-card-content>
                    </mat-card>

                   
                </div>
            </div>
            <div class="row" style="margin-top:5px;">
                <div class="col-12">
                    <mat-card>
                        <mat-card-content>
                            <span class="ace-title-level-2">Comments</span><br />
                        {{parkerDetail.comments}}
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </div>
    
    
            </mat-card-content>
        </mat-card>
    </ng-container>
    
    
    <ng-container *ngIf="isParkerEditMode">
        
     <app-parkers-v2-edit 
        [parkerDetailInput]="parkerDetail"
        (editFinishedEvent)="OnEditChangesCompleted($event)"
    ></app-parkers-v2-edit>
        
    </ng-container>

